// document.cookie = "region_selected=true; path=/; domain=.weego.eu; max-age=86400";

//..
document.addEventListener("DOMContentLoaded", function () {

  // console.log('EU Geo Redirect Script Loaded 1p');

  const continueBtn = document.querySelector('.location-popup .btn');

  // console.log('EU Geo Redirect Script Loaded');
  if (continueBtn) {
    continueBtn.addEventListener('click', function () {

      document.cookie =
        "region_selected=true; path=/; domain=.weego.eu; max-age=31536000";

    });
  } 

});



document.addEventListener("DOMContentLoaded", () => {
  // Hide initially
  const style = document.createElement("style");
  style.innerHTML = `
    #shopify-pc__banner,
    .shopify-pc__banner {
      display: none !important;
    }
  `;
  document.head.appendChild(style);

  // Show after delay
  setTimeout(() => { 
    style.remove();
    
  }, 15000);

});

/* =====================================================
   GLOBAL THEME JS
   Cleaned + Fixed EU Geo Redirect (No Infinite Loop)
   ===================================================== */

$(document).ready(function () {

  /* =========================
     Smooth Scroll
     ========================= */
  $("a").on("click", function (event) {
    if (this.hash !== "") {
      event.preventDefault();
      var hash = this.hash;

      $("html, body").animate(
        { scrollTop: $(hash).offset().top },
        800,
        function () {
          window.location.hash = hash;
        }
      );
    }
  });

  /* =========================
     Buy It Now Button
     ========================= */
  $(".menu-buy-now").parent().parent().on("click", function (e) {
    e.preventDefault();
    $(".slideshow:first-child").find(".btn").click();
  });

  /* =========================
     Jump to Buy Now if Variant Param Exists
     ========================= */
  var urlParams = new URLSearchParams(window.location.search);
  var variantParam = urlParams.get("variant");

  if (variantParam && variantParam > 0) {
    $(".slideshow:first-child").find(".btn").click();
  }

  /* =========================
     Swiper Arrows
     ========================= */
  $(".swiper-arrow-added-right").click(function (e) {
    e.preventDefault();
    $(".swiper-pagination-bullet-active").next().click();
  });

  $(".swiper-arrow-added-left").click(function (e) {
    e.preventDefault();
    $(".swiper-pagination-bullet-active").prev().click();
  });

  /* =========================
     Image → Variant Selector
     ========================= */
  $(".product-thumbnails__item-link").click(function () {
    var idx = $(this).parent().index();
    var swatches = $(".product__color-swatch");

    if (swatches.length > 0 && swatches[idx]) {
      swatches[idx].click();
      var txt = $(swatches[idx]).attr("data-option-value");
      updateSwatchLabel(txt);
    } else {
      updateSwatchLabel(null);
    }
  });

  $(".product__color-swatch").click(function () {
    updateSwatchLabel($(this).attr("data-option-value"));
  });

  function updateSwatchLabel(txt) {
    var prep = "<strong>Model:</strong> ";
    var lbl = $(".swatch-label");

    if (!txt) {
      lbl.html("&nbsp;");
      return;
    }

    lbl.html(prep + txt);
  }

});

/* =====================================================
   EU STORE – PRESELECT COUNTRY ONLY (NO AUTO SWITCH)
   ===================================================== */

   
(function () {

  
  // Only run on EU domain
  if (!window.location.hostname.includes("weego.eu")) return;

  const params = new URLSearchParams(window.location.search);
  const countryParam = params.get("country");

  if (!countryParam) return;

  document.addEventListener("DOMContentLoaded", function () {

    const select = document.querySelector('select[name="country_code"]');
    if (!select) return;

    const exists = Array.from(select.options).some(option =>
      option.value.toLowerCase() === countryParam.toLowerCase()
    );

    console.log("Country Param:", countryParam, "Exists in Dropdown:", exists);
    
    if (exists) {
      select.value = countryParam.toUpperCase();
    }

  });

})();
 

// document.addEventListener("DOMContentLoaded", () => {
  // setTimeout(() => {
  //   const banner =
  //     document.querySelector("#shopify-pc__banner") ||
  //     document.querySelector(".shopify-pc__banner");

  //   if (banner) {
  //     banner.style.opacity = "1";
  //     banner.style.visibility = "visible";
  //     banner.style.pointerEvents = "auto";
  //   }
  // }, 5000); // 5 sec delay
// });



// document.addEventListener('DOMContentLoaded', function () {

//   const form = document.querySelector('.location-popup');

//   if (!form) return;

//   form.addEventListener('submit', function () {

//     const currentAction = form.action || window.location.pathname;
//     const separator = currentAction.includes('?') ? '&' : '?';

//     form.action =
//       currentAction + separator + 'region_selected=true';

//   });

// });

// document.addEventListener('DOMContentLoaded', function() {
//   const form = document.querySelector('.location-popup');

//   if (!form) return;

//   const returnTo = form.querySelector('input[name="return_to"]');

//   if (returnTo) {
//     returnTo.value = window.location.pathname + '?location_selected=1';
//   }
// });
document.addEventListener('DOMContentLoaded', () => {

  if (!document.body.classList.contains('template-page-eu-withdrawal-form')) {
    return;
  }

  const params = new URLSearchParams(window.location.search);

  const order = params.get('order');
  const email = params.get('email');
  const name = params.get('name');

  const host = document.querySelector('[data-widerruf-inline]');

  if (!host || !host.shadowRoot) {
    return;
  }

  const orderInput = host.shadowRoot.querySelector('[data-widerruf-order-input]');
  const emailInput = host.shadowRoot.querySelector('input[name="email"]');
  const nameInput = host.shadowRoot.querySelector('[data-widerruf-name-input]');

  if (name && nameInput) {
    nameInput.value = name;
    nameInput.dispatchEvent(new Event('input', { bubbles: true }));
  }

  if (order && orderInput) {
    orderInput.value = order;
    orderInput.dispatchEvent(new Event('input', { bubbles: true }));
  }

  if (email && emailInput) {
    emailInput.value = email;
    emailInput.dispatchEvent(new Event('input', { bubbles: true }));
  }
});

document.addEventListener('DOMContentLoaded', () => {

  return; // Disable for now as we don't have the form live yet

  const interval = setInterval(() => {
    const block = document.querySelector('.widerruf-form-block');

    if (!block?.shadowRoot) return;

    const branding = block.shadowRoot.querySelector('.widerruf-form-branding');

    if (branding) {
      branding.remove();
      clearInterval(interval);
    }
  }, 250);
});


